<template>
    <header class="page_header">
        <div class="platform-logo-container">
            <div class="title platform-logo-container__title">
                <!-- <i class="logo"></i> -->
                浦口区民办校资金监管驾驶舱</div>
        </div>
        <div class="platform-date-container">
            {{ dateStr }}
        </div>
    </header>
</template>

<script>
import moment from 'moment';
export default {
    name: 'page-header',
    data() {
        return {
            dayMap: [
                '星期日',
                '星期一',
                '星期二',
                '星期三',
                '星期四',
                '星期五',
                '星期六'
            ],
            dateStr: '',
            dateTimer: null
        }
    },
    created() {
        this.recursionDateRender()
    },
    methods: {
        recursionDateRender() {
            const day = this.dayMap[moment().format('d')]
            this.dateStr = moment().format('YYYY-MM-DD HH:mm:ss ') + day
            this.dateTimer && clearTimeout(this.dateTimer)
            this.dateTimer = setTimeout(() => {
                this.recursionDateRender()
            }, 1000)
        }
    }
}
</script>

<style lang='scss' scoped>
@import "~@/styles/mixin";
.page_header {
    width: 1920px;
    height: 71px;
    line-height: 70px;
    color: #fff;
    background-color: #22273B;
    .platform-logo-container {
        float: left;
        font-size: 32px;
        height: 100%;
        margin-left: 72px;
        .logo {
            @include middleIB;
            @include wh(50px, 50px);
            position: relative;
            top: -2px;
            margin-right: 20px;
            background: no-repeat center center / contain;
            background-image: url('~@/assets/images/logo.png');
        }
    }
    .platform-date-container {
        float: right;
        font-size: 18px;
        height: 100%;
        margin-right: 72px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/iPayment/cockpitHome/components/Header.vue